module.exports = __webpack_public_path__ + "media/images/wmb_coalition_logo-7ff7e6c9.png";